import initRecordings from '../../../actions/recordings/initRecordings';
import Recording from '../../../classes/record';
import { Observer } from 'rxjs';
import { channelsSelector } from '../../../store/slices/channels.slice';
import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { userSelector } from '../../../store/slices/user.slice';
import {
  recordingSelector,
  setCurrentRecording,
} from '../../../store/slices/recordings.slice';

function useRecords() {
  const dispatch = useAppDispatch();
  const { currentChannel } = useAppSelector(channelsSelector);
  const { finished, pending, identifiers } = useAppSelector(recordingSelector);
  const { userId } = useAppSelector(userSelector);

  const observerRef = useRef<Observer<never> | null>(null);

  useEffect(() => {
    return () => {
      observerRef.current && observerRef.current.complete();
    };
  }, []);

  useEffect(() => {
    if (userId) {
      observerRef.current = initRecordings();
    }
  }, [userId]);

  useEffect(() => {
    const identifier = identifiers.find((item) => {
      return (
        item.code === currentChannel?.currentEvent?.eventId ||
        item.code === currentChannel?.currentEvent?.seasonCode
      );
    });
    dispatch(setCurrentRecording(new Recording(identifier?.code)));
  }, [currentChannel, finished, pending, identifiers]);
}

export default useRecords;
